export default __webpack_public_path__ + "static/media/title-featured-cases.23aac179.png";